export enum UserRoleEnum {
    Admin = 'Admin',
    Scanner = 'Scanner',
}